"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/popover/examples/default.ts';
var PopoverExample = /** @class */ (function () {
    function PopoverExample() {
        this.arrow = true;
        this.closeOnEscapeKey = true;
        this.closeOnContentClick = false;
        this.interactionType = 'click';
        this.hasBackdrop = false;
        this.openOnTriggerFocus = true;
        this.position = 'bottom';
        this.inline = false;
    }
    PopoverExample.prototype.view = function () {
        var content = [
            (0, mithril_1.default)('p', 'Popover paragraph content'),
            (0, mithril_1.default)(_1.Button, {
                class: _1.Classes.POPOVER_DISSMISS,
                label: 'Dismiss',
                size: 'xs'
            })
        ];
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Popover, {
                closeOnEscapeKey: this.closeOnEscapeKey,
                closeOnContentClick: this.closeOnContentClick,
                content: content,
                hasArrow: this.arrow,
                hasBackdrop: this.hasBackdrop,
                inline: this.inline,
                interactionType: this.interactionType,
                openOnTriggerFocus: this.openOnTriggerFocus,
                position: this.position,
                trigger: (0, mithril_1.default)(_1.Button, {
                    label: 'Popover trigger',
                    intent: 'primary'
                })
            })
        ]);
    };
    PopoverExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Position'),
            (0, mithril_1.default)(examples_1.PopoverPositionSelect, { onSelect: function (position) { return _this.position = position; } }),
            (0, mithril_1.default)('h5', 'Interaction'),
            (0, mithril_1.default)(_1.Select, {
                fluid: true,
                options: Object.keys(_1.PopoverInteraction).map(function (key) { return _1.PopoverInteraction[key]; }),
                onchange: function (e) {
                    var target = e.target;
                    _this.interactionType = target.value;
                },
                size: 'xs',
                value: this.interactionType
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Close on ESC key',
                checked: this.closeOnEscapeKey,
                onchange: function () { return _this.closeOnEscapeKey = !_this.closeOnEscapeKey; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Close on content click',
                checked: this.closeOnContentClick,
                onchange: function () { return _this.closeOnContentClick = !_this.closeOnContentClick; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Has arrow',
                checked: this.arrow,
                onchange: function () { return _this.arrow = !_this.arrow; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: [
                    'Open on trigger focus',
                    (0, mithril_1.default)(_1.Tooltip, {
                        content: 'Only applies to hover interactions',
                        trigger: (0, mithril_1.default)(_1.Icon, {
                            class: 'cui-example-info-trigger',
                            name: _1.Icons.INFO,
                            size: 'xs'
                        }),
                        size: 'xs'
                    })
                ],
                checked: this.openOnTriggerFocus,
                onchange: function () { return _this.openOnTriggerFocus = !_this.openOnTriggerFocus; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Has backdrop',
                checked: this.hasBackdrop,
                onchange: function () { return _this.hasBackdrop = !_this.hasBackdrop; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Render Inline',
                checked: this.inline,
                onchange: function () { return _this.inline = !_this.inline; }
            })
        ];
    };
    return PopoverExample;
}());
exports.PopoverExample = PopoverExample;
